export class SiteData {
  navigationObject: any;
  globalFooterObject: any;
  constructor() { }
}
